<div class="chart-container d-flex justify-content-center h-100">
  <canvas id="{{ chartId }}"></canvas>
</div>
